import { createSlice } from '@reduxjs/toolkit';
import { getParticipantGroup } from './ParticipantGroupApi';

const initialState = {
  isLoadingParticipantGroups: false,
  participantGroups: [],
};

const participantGroupSlice = createSlice({
  name: 'participantGroupSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParticipantGroup.pending, (state) => {
        state.isLoadingParticipantGroups = true;
      })
      .addCase(getParticipantGroup.fulfilled,
        (state, { payload }) => {
          state.participantGroups = payload;
          state.isLoadingParticipantGroups = false;
        })
      .addCase(getParticipantGroup.rejected, (state) => {
        state.isLoadingParticipantGroups = false;
      });
  },
});

export default participantGroupSlice.reducer;
